import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Download, Loader2, FileText } from "lucide-react";
import { useT, useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startDownload = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = url.split("/").pop();
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const GuidePdf = () => {
  const t = useT();
  const { lang } = useLang();
  const [form, setForm] = useState({ name: "", email: "", consent: false });
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent) return toast.error(t("pdf.errConsent", "Per scaricare la guida accetta il trattamento dei dati."));
    setLoading(true);
    try {
      const res = await axios.post(`${API}/guide-leads`, { ...form, lang });
      const link = res.data?.url;
      if (link) {
        setUrl(link);
        startDownload(link);
      }
      toast.success(t("pdf.ok", "Grazie! Il download della guida è partito."));
    } catch (err) {
      toast.error(err?.response?.status === 429 ? t("form.err429", "Troppe richieste, riprova più tardi.") : t("pdf.err", "Controlla l'email e riprova."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid gap-10 bg-[#121110] p-8 text-[#F7F5F0] sm:p-12 lg:grid-cols-12 lg:items-center" data-testid="guide-pdf-box">
      <div className="lg:col-span-5">
        <FileText className="h-10 w-10 text-[#D98A52]" />
        <h3 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl">
          {t("pdf.h2", "Scarica le due guide")} <em className="font-serif font-normal text-[#D98A52]">{t("pdf.hem", "in PDF.")}</em>
        </h3>
        <p className="mt-4 text-base leading-relaxed text-[#CFC8BC]">{t("pdf.text2", "I 4 errori da evitare e come scegliere tra X-LAM e telaio, in un unico PDF. Lasciaci la tua email: il download parte subito e ti inviamo una copia anche per email.")}</p>
      </div>
      {url ? (
        <div className="lg:col-span-6 lg:col-start-7" data-testid="guide-pdf-done">
          <p className="text-lg">{t("pdf.done", "Grazie! Se il download non è partito, usa il pulsante qui sotto.")}</p>
          <a href={url} download className="btn-amber mt-6" data-testid="guide-pdf-link">{t("pdf.again", "Scarica il PDF")} <Download className="h-4 w-4" /></a>
        </div>
      ) : (
        <form onSubmit={submit} className="grid gap-6 lg:col-span-6 lg:col-start-7" data-testid="guide-pdf-form">
          <label className="block">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#A39E93]">{t("pdf.name", "Nome (facoltativo)")}</span>
            <input className="field" value={form.name} maxLength={120} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="guide-pdf-name" />
          </label>
          <label className="block">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#A39E93]">Email *</span>
            <input className="field" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="guide-pdf-email" />
          </label>
          <label className="flex items-start gap-3 text-sm text-[#CFC8BC]">
            <input type="checkbox" checked={form.consent} onChange={(e) => setForm({ ...form, consent: e.target.checked })} className="mt-1 h-4 w-4 accent-[#C26D38]" data-testid="guide-pdf-consent" />
            <span>{t("pdf.consent", "Accetto il trattamento dei dati e di essere ricontattato da Emma Industrie per informazioni sui suoi prodotti.")}</span>
          </label>
          <button type="submit" disabled={loading} className="btn-amber w-fit disabled:opacity-60" data-testid="guide-pdf-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} {t("pdf.submit", "Scarica la guida gratuita")}
          </button>
        </form>
      )}
    </div>
  );
};
